<template>
  <div class="full-height">
    <ProgramDashboardV2 v-if="isDashboardV2" />
    <ProgramDashboardV1 v-else />
  </div>
</template>

<script>
import ProgramDashboardV1 from "./ProgramDashboardV1.vue";
import ProgramDashboardV2 from "./ProgramDashboardV2.vue";

export default {
  name: "ProgramDashboard",
  components: {
    ProgramDashboardV1,
    ProgramDashboardV2,
  },
  computed: {
    isDashboardV2() {
      const config = this.$store.getters.dashboardConfig;
      return config && config.version === "v2";
    },
  },
};
</script>
